export interface IPillButtonDTO {
  id: string;
  title: string;
  subtitle?: string;
  selected?: boolean;
  payload?: any;
}

export class PillButtonDTO implements IPillButtonDTO {
  constructor(
    public id: string,
    public title: string,
    public subtitle?: string,
    public selected?: boolean,
    public payload?: any,
  ) {}
}
